var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("InformationWrapper", {
        scopedSlots: _vm._u([
          {
            key: "primary",
            fn: function () {
              return [
                _c(
                  "InformationCard",
                  { attrs: { title: "Contractors" } },
                  [
                    _c("ItemChipsWithMore", {
                      attrs: {
                        limit: 100,
                        items: _vm.contractors,
                        isPerson: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ itemsToRender }) {
                            return _vm._l(
                              itemsToRender,
                              function (contractorItem) {
                                return _c(
                                  "EmployeeRemovedFromCompanyTooltip",
                                  {
                                    key: contractorItem.id,
                                    attrs: {
                                      disabled: !contractorItem.deleted,
                                    },
                                  },
                                  [
                                    _c("ItemChip", {
                                      attrs: {
                                        itemId: contractorItem.id,
                                        itemName: contractorItem.name,
                                        itemRole: contractorItem.role,
                                        itemExtra: contractorItem.extra,
                                        avatar: contractorItem.avatar,
                                        routeParams: contractorItem.routeParams,
                                        routeName: _vm.contractorRoute,
                                        removed: contractorItem.deleted,
                                        isPerson: "",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "InformationCard",
                  { staticClass: "mt-4", attrs: { title: "Managers" } },
                  [
                    _c("ItemChipsWithMore", {
                      attrs: {
                        limit: 100,
                        items: _vm.managers,
                        routeName: _vm.managerRoute,
                        isPerson: "",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "InformationCard",
                  { staticClass: "mt-4", attrs: { title: "Clients" } },
                  [
                    _c("ItemChipsWithMore", {
                      attrs: {
                        limit: 100,
                        items: _vm.projects,
                        routeName: _vm.projectRoute,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "InformationCard",
                  { staticClass: "mt-4", attrs: { title: "Postings" } },
                  [
                    _c("ItemChipsWithMore", {
                      attrs: {
                        limit: 100,
                        items: _vm.postings,
                        routeName: _vm.postingRoute,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "secondary",
            fn: function () {
              return [
                _c(
                  "InformationCard",
                  { attrs: { title: "Skills" } },
                  [
                    _c("ItemChipsWithMore", {
                      attrs: { limit: 100, items: _vm.skills },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }